import React, { useEffect } from "react";
import ContentTool from "./ContentTool";
import { useUpdate } from "ahooks";
import { useColContext } from "./ColContext";

export default React.memo(({ node, gutter }) => {
  const { colShareRefs } = useColContext();

  const updateCurrentCol = useUpdate();

  useEffect(() => {
    colShareRefs.updateCurrentCol = updateCurrentCol;
  }, []);

  if (node.children.length === 0) {
    node.addChild({
      data: {},
      type: "no-content",
      style: "",
      children: [],
    });
  }

  return (
    <div className={node.className} style={{paddingLeft: gutter, paddingRight: gutter}} onMouseEnter={(e) => e.stopPropagation()}>
      {
        node.children.map((node, cntIndex) => {
          return <ContentTool key={node.id} node={node} cntIndex={cntIndex}/>
        })
      }
    </div>
  );
});
